/**
 * 积分配置接口
 */
export default {
    BASE_URL: '/crm/integral',
    NAMESPACE: 'integralEquip',
    api: [
        {
            name: 'getCompanyBasicPoint',
            desc: '获取企业积分基础配置列表',
            method: 'GET',
            path: '/org/conf/list'
        },
        {
            name: 'getCompanyRewardPoint',
            desc: '获取企业积分奖励规则配置列表',
            method: 'GET',
            path: '/org/rule/list'
        },
        {
            name: 'pointBasicDetail',
            desc: '积分基础配置详情',
            method: 'GET',
            path: '/conf/detail'
        },
        {
            name: 'pointRewardDetail',
            desc: '积分奖励配置详情',
            method: 'GET',
            path: '/rule/detail'
        },
        {
            name: 'pointBasicEdit',
            desc: '积分基础配置编辑',
            method: 'POST',
            path: '/conf/edit'
        },
        {
            name: 'pointRewardEdit',
            desc: '积分奖励配置编辑',
            method: 'POST',
            path: '/rule/edit'
        },
        {
            name: 'getPersonalBasicPoint',
            desc: '获取个人积分基础配置列表',
            method: 'GET',
            path: '/mem/conf/list'
        },
        {
            name: 'getPersonalRewardPoint',
            desc: '获取个人积分奖励规则配置列表',
            method: 'GET',
            path: '/mem/rule/list'
        },
        {
            name: 'validPeriod',
            desc: '获取积分基础配置有效日期',
            method: 'GET',
            path: '/validPeriod'
        },
        {
            name: 'yearUnit',
            desc: '获取积分配置年月日',
            method: 'GET',
            path: '/yearUnit'
        },
        {
            name: 'isEnable',
            desc: '获取积分启用状态',
            method: 'POST',
            path: '/rule/enable'
        },
        {
            name: 'checkTask',
            desc: '校验是否修改规则',
            method: 'GET',
            path: '/rule/checkTask'
        },
    ]
}
  


// WEBPACK FOOTER //
// ./src/api/apis/integral/equip.js